var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table',{key:_vm.items.length,attrs:{"loader":_vm.loadData,"headers":_vm.items && _vm.items[0]?.email ? _vm.headers : _vm.headers1,"view-handler":_vm.view},on:{"done":function($event){return _vm.$router.back()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }